import { render, staticRenderFns } from "./ManageCategoriesModal.vue?vue&type=template&id=153e374c&scoped=true"
import script from "./ManageCategoriesModal.vue?vue&type=script&lang=js"
export * from "./ManageCategoriesModal.vue?vue&type=script&lang=js"
import style0 from "./ManageCategoriesModal.vue?vue&type=style&index=0&id=153e374c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e374c",
  null
  
)

export default component.exports